import { event } from '@abyss/web/tools/event';

export const adobeModalCloseTrackEvent = (name) => {
  event('MODAL_CLOSE_EVENT', {
    modal: {
      name: name.toLowerCase().replaceAll('-', ' '),
    },
  });
};
